export const rockRidgeIdentifier = 'IEEE_P1282';
//# sourceMappingURL=constants.js.map